import { observer } from 'mobx-react';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Appointments from './Appointments';

function AppointmentsRoute() {
	return (
		<Routes>
			<Route path="*" element={<Appointments />} />
		</Routes>
	);
}

export default observer(AppointmentsRoute);
